/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Layout, Row, Col } from 'antd';
import { connect } from 'react-redux';
import propTypes, { object } from 'prop-types';
import { Div } from './style';
import { changeRtlMode, changeLayoutMode, changeMenuMode } from '../redux/theme-layout/action-creator';
import { getSession } from '../services/storage-service';
import './menu-items.css';
import AvatarImage from '../components/cp-account-image';
import AuthInfo from '../kiosk/components/cp-user-profile/cp-info';
import { getKioskTxnCreateHedaer } from '../services/business-details-service';
import logger from '../services/logger';

const { Content } = Layout;
const ThemeLayout = (WrappedComponent) => {
  class LayoutComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isFullScreen: false,
      };
      // Bind the methods
      this.updateDimensions = this.updateDimensions.bind(this);
      this.disableRightClick = this.disableRightClick.bind(this);
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      window.addEventListener('contextmenu', this.disableRightClick);
      this.updateDimensions();
    }

    componentDidUpdate() { }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
      window.removeEventListener('contextmenu', this.disableRightClick);
    }

    // eslint-disable-next-line class-methods-use-this
    disableRightClick = (e) => {
      e.preventDefault();
    };

    updateDimensions() {
      this.setState({
        // collapsed: window.innerWidth <= 1200 && true,
      });
    }

    render() {
      const { ChangeLayoutMode, bizData } = this.props;

      const userRole = getSession(`${bizData?.id}_biz_Accocunt_user_obj`, true)?.roleType;
      const isMobileDevice = getSession('DEVICE_TYPE');
      const darkMode = ChangeLayoutMode;
      const serviceLabel = getKioskTxnCreateHedaer();

      const handleFullScreen = () => {
        const { isFullScreen } = this.state;
        const element = document.documentElement; // Get the root HTML element

        if (!isFullScreen) {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        }
        if (document.exitFullscreen) {
          document.exitFullscreen().catch((err) => {
            logger.error('Exit full screen error:', err);
          });
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }

        // Toggle the full-screen state
        this.setState((prevState) => ({
          isFullScreen: !prevState.isFullScreen,
        }));
      };

      const headerStyle = {
        borderBottom: '1px solid #E1E1E1',
        // gap: '55px',
        height: '70px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      };

      const bizTitle = {
        color: '#384D48',
        fontSize: '25px',
        fontWeight: '500',
        textAlign: 'center',
        width: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      };

      const profileLogout = {
        color: '#384D48',
        fontSize: '25px',
        fontWeight: '500',
        textAlign: 'end',
      };

      return (
        <Div darkMode={darkMode} className="kiosk_mode">
          <Layout className="layout">
            <Layout>
              <Row style={headerStyle}>
                <Col span={4} className="align-center-v navbar-brand mt-5 m-l-10">
                  <div className="striking-logo top-menu mouse-pointer" onClick={handleFullScreen}>
                    {bizData?.logoUrl ? (
                      <AvatarImage image={bizData?.logoUrl} type="IMAGE" classValue="" sizeVal={50} />
                    ) : (
                      <AvatarImage
                        image={bizData?.title?.slice(0, 1).toUpperCase()}
                        classValue=""
                        type="AVATAR"
                        sizeVal={50}
                      />
                    )}
                  </div>
                </Col>

                <Col span={14} className="align-center-v navbar-brand mt-5">
                  <div style={bizTitle}>{serviceLabel || `Welcome to ${bizData?.title}`}</div>
                </Col>

                <Col span={4} className="align-center-v navbar-brand mt-5 m-r-10">
                  <div style={profileLogout}>
                    <AuthInfo />
                  </div>
                </Col>
              </Row>
            </Layout>
            <Layout>
              <Layout
                className={isMobileDevice === 'DESKTOP' ? 'atbd-main-layout' : 'atbd-main-layout hide-atbd-main-layout'}
              >
                <Content>
                  <WrappedComponent {...this.props} />
                </Content>
              </Layout>
            </Layout>
          </Layout>
        </Div>
      );
    }
  }

  const mapStateToProps = (state) => {
    return {
      ChangeLayoutMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      bizData: state?.biz?.bizData,
    };
  };

  const mapStateToDispatch = (dispatch) => {
    return {
      changeRtl: (rtl) => dispatch(changeRtlMode(rtl)),
      changeLayout: (show) => dispatch(changeLayoutMode(show)),
      changeMenuMode: (show) => dispatch(changeMenuMode(show)),
    };
  };

  LayoutComponent.propTypes = {
    ChangeLayoutMode: propTypes.bool,
    rtl: propTypes.bool,
    topMenu: propTypes.bool,
    changeRtl: propTypes.func,
    changeLayout: propTypes.func,
    changeMenuMode: propTypes.func,
    bizData: object,
    location: object,
    match: object,
  };

  return connect(mapStateToProps, mapStateToDispatch)(LayoutComponent);
};
export default ThemeLayout;
